export default "__VITE_ASSET__BrBj7qI2__"